import {
	isEmpty,
	alphabetizeTiles,
	isTilesInBlacklist,
	getDictionaryByValue,
	sortObjectKeys,
} from "@/common/functions";

import { DICTIONARIES_IN_API, DICTIONARY_LISTS } from "@/common/consts";

export default {
	loading: (state) => state.status.loading,
	error: (state) => state.status.error,
	/** @todo remove unused getters */
	getUnsortedTiles: (state) => {
		if (state.query.unsortedTiles.length) return state.query.unsortedTiles;
		return state.query.tiles;
	},
	getAdvancedSearchOptions: (state) => {
		let o = {};
		if (state.query.startsWith.length) o.starts = state.query.startsWith;
		if (state.query.endsWith.length) o.ends = state.query.endsWith;
		if (state.query.contains.length) o.contains = state.query.contains;
		if (state.query.wordLength !== null)
			o.word_length = parseInt(state.query.wordLength);
		return o;
	},
	getAnagram: (state) =>
		alphabetizeTiles(state.query.tiles, state.navigation.current),
	nonWildcardTiles: (state, getters) =>
		getters.getUnsortedTiles.replace(/_/g, ""),
	countNonWildcardTiles: (state, getters) => getters.nonWildcardTiles.length,
	countWildcards: (state) => state.query.tiles.split("_").length - 1,
	lastVisited: (state) => state.lastVisited,
	getSafeTiles: (state, getters) => {
		if (isTilesInBlacklist(state.query.tiles)) return getters.getAnagram;
		return state.query.tiles;
	},
	getFinderHeight: (state) => state.finderHeight,
	getSavedWords: (state) => state.savedWords,
	getSavedWordsList: (state) =>
		state.savedWords.map((el) => {
			return el.word;
		}),
	wordGroupKeys: (state) =>
		Object.keys(state.words)
			.filter((k) => state.words[k])
			.sort((a, b) => b - a),
	combinedWordGroupKeys: (state) => {
		let sortedWords = sortObjectKeys(state.words);
		sortedWords = sortedWords.map((sortedGroupKey) => {
			return { alternativeWords: false, key: sortedGroupKey };
		});

		let sortedAlternativeWords = sortObjectKeys(
			state.alternativeResults.words
		);
		sortedAlternativeWords = sortedAlternativeWords.map(
			(sortedGroupKey) => {
				return { alternativeWords: true, key: sortedGroupKey };
			}
		);

		return [...sortedWords, ...sortedAlternativeWords];
	},
	getCurrentDictionary: (state) => {
		const stateDictionary = getDictionaryByValue(
			DICTIONARY_LISTS.DEFAULT,
			state.query.dictionary
		);
		return isEmpty(stateDictionary) ? {} : stateDictionary;
	},
	getOpenedModals: (state) => (id) => {
		return (
			!isEmpty(state.openedModals) &&
			!isEmpty(state.openedModals[id]) &&
			state.openedModals[id] === true
		);
	},
	combinedWords: (state) => {
		return { ...state.words, ...state.alternativeResults.words };
	},
	isLoadingSavedWords: (state) => {
		return state.loadingSavedWords;
	},
	hasScoreField: (state) => {
		return ![
			DICTIONARIES_IN_API.ANAGRAM,
			DICTIONARIES_IN_API.PICS,
			DICTIONARIES_IN_API.JUM,
			DICTIONARIES_IN_API.CONNECT,
			DICTIONARIES_IN_API.COOKIES,
			DICTIONARIES_IN_API.TWIST,
			DICTIONARIES_IN_API.CROSS,
			DICTIONARIES_IN_API.BRAIN,
			DICTIONARIES_IN_API.STORY,
			DICTIONARIES_IN_API.SWIPE,
			DICTIONARIES_IN_API.ALL,
			DICTIONARIES_IN_API.WORDLE,
			DICTIONARIES_IN_API.WS,
		].includes(state.query.dictionary);
	},
};
